import { c as _c } from "react/compiler-runtime";
import { CSpinner } from "@coreui/react";
import { IconCheck, IconAlertTriangle } from "@tabler/icons-react";
export type ProviderState = "searching" | "done" | "error";
export function ProviderChip(t0) {
  const $ = _c(22);
  const {
    providerId,
    state,
    count,
    errorReason: reason
  } = t0;
  let t1;
  if ($[0] !== state) {
    t1 = state === "searching" && <CSpinner size="sm" data-role="spinner" className="provider-chip-spinner" />;
    $[0] = state;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== state) {
    t2 = state === "done" && <IconCheck size={14} />;
    $[2] = state;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== state) {
    t3 = state === "error" && <IconAlertTriangle size={14} />;
    $[4] = state;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== providerId) {
    t4 = <span className="provider-chip-name">{providerId}</span>;
    $[6] = providerId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== count || $[9] !== state) {
    t5 = state === "done" && typeof count === "number" && <span className="provider-chip-count" data-role="count">{count}</span>;
    $[8] = count;
    $[9] = state;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== reason || $[12] !== state) {
    t6 = state === "error" && reason && <span className="provider-chip-reason">{reason}</span>;
    $[11] = reason;
    $[12] = state;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== state || $[15] !== t1 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = <span className="provider-chip d-inline-flex align-items-center gap-2" data-state={state}>{t1}{t2}{t3}{t4}{t5}{t6}</span>;
    $[14] = state;
    $[15] = t1;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}